// removed by extract-text-webpack-plugin
module.exports = {"hide":"_1w9i-RgGXYB6ugdxgM09W2","gallery":"_3ZLjTYSJNEkuilsuCb-btC","active":"_3VO69avGuGYOtJWuFesvg3","dots":"_28ptU7KQB7a4bxLMxgiDk7","label":"qR62WqZVpLCgnCHdunFZh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetPopupImageViewer/AssetPopupImageViewer.scss
// module id = 2704
// module chunks = 0